"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9093],{

/***/ 19093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LocationNav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50998);
/* harmony import */ var _components_CustomDropdown_CustomDropdown_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61707);
/* harmony import */ var _components_CustomButtons_Button_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16719);
/* harmony import */ var constants_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68148);
/* harmony import */ var _styles_jss_bbhost_pages_componentsSections_navbarsStyle_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28886);
/*eslint-disable*/ 



// @material-ui/core components



// @material-ui/icons

// core components





var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_styles_jss_bbhost_pages_componentsSections_navbarsStyle_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z);
function LocationNav() {
    var classes = useStyles();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var locale = router.locale, locales = router.locales, defaultLocale = router.defaultLocale, pathname = router.pathname;
    var actualLocale = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            constants_js__WEBPACK_IMPORTED_MODULE_6__/* .localeText */ .tu[locale].icon,
            "  ",
            constants_js__WEBPACK_IMPORTED_MODULE_6__/* .localeText */ .tu[locale].text
        ]
    });
    var localeList = locales.map(function(local_slug, key) {
        if (local_slug !== locale) {
            if (defaultLocale === local_slug) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_CustomButtons_Button_js__WEBPACK_IMPORTED_MODULE_5__["default"], {
                href: pathname,
                color: "transparent",
                className: classes.dropdownLink,
                children: [
                    constants_js__WEBPACK_IMPORTED_MODULE_6__/* .localeText */ .tu[local_slug].icon,
                    " ",
                    constants_js__WEBPACK_IMPORTED_MODULE_6__/* .localeText */ .tu[local_slug].text
                ]
            });
            else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_CustomButtons_Button_js__WEBPACK_IMPORTED_MODULE_5__["default"], {
                href: "/" + local_slug + pathname,
                color: "transparent",
                className: classes.dropdownLink,
                children: [
                    constants_js__WEBPACK_IMPORTED_MODULE_6__/* .localeText */ .tu[local_slug].icon,
                    " ",
                    constants_js__WEBPACK_IMPORTED_MODULE_6__/* .localeText */ .tu[local_slug].text
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: classes.listItem,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomDropdown_CustomDropdown_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            noLiPadding: true,
            navDropdown: true,
            hoverColor: "info",
            buttonText: actualLocale,
            buttonProps: {
                className: classes.navLink,
                color: "transparent"
            },
            dropdownList: localeList
        })
    });
}


/***/ })

}]);